import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { STORES_APP_DEF_ID } from '@wix/wixstores-client-core/dist/src/constants';
const USE_GET_CLIENT_CONFIG_FROM_PUBLIC_API = 'specs.stores.UseGetClientConfigFromPublicApi';
const DEFAULT_LANGUAGE = 'en';
const SUPPORTED_LANGUAGES = new Set(['de', 'en', 'es', 'fi', 'fr', 'it', 'ja', 'ko', 'pl', 'pt', 'ru', 'tr', 'nl', 'da', 'sv', 'no', 'hi', 'he', 'zh', 'id', 'ms', 'th', 'tl', 'ro', 'hu', 'el', 'ar', 'bg', 'cs', 'uk', 'ua', 'lt', 'vi', 'ca', 'sl', 'sk', 'hr', 'lv']);
function getSupportedLanguageOrDefault(language) {
  return SUPPORTED_LANGUAGES.has(language) ? language : DEFAULT_LANGUAGE;
}
export async function showSuggestedCurrencyAutoSwitchToast(intent) {
  try {
    const autoswitchModule = await import('@wix/payments-currency-autoswitch');
    autoswitchModule.showSuggestedCurrencyAutoSwitchToast({
      intent
    });
  } catch (e) {
    console.error(e);
    return;
  }
}
export function renderSuggestedCurrencyAutoSwitchToastOnce(intent, renderedIntentId, renderToast) {
  if (renderToast === void 0) {
    renderToast = showSuggestedCurrencyAutoSwitchToast;
  }
  if (!intent || renderedIntentId === intent.id || typeof window === 'undefined') {
    return renderedIntentId;
  }
  void renderToast(intent);
  return intent.id;
}
export class ViewerContext {
  constructor(siteStore, experiments, wixCodeApi, flowAPI) {
    this.siteStore = siteStore;
    this.experiments = experiments;
    this.wixCodeApi = wixCodeApi;
    this.flowAPI = flowAPI;
    _defineProperty(this, "_locale", void 0);
    _defineProperty(this, "_currency", void 0);
    _defineProperty(this, "_layoutDirection", void 0);
    _defineProperty(this, "_premiumFeatures", void 0);
    _defineProperty(this, "_price", void 0);
    _defineProperty(this, "_tax", void 0);
    _defineProperty(this, "_shipping", void 0);
  }
  get locale() {
    return this._locale;
  }
  get currency() {
    return this._currency;
  }
  get layoutDirection() {
    return this._layoutDirection;
  }
  get premiumFeatures() {
    return this._premiumFeatures;
  }
  get price() {
    return this._price;
  }
  get tax() {
    return this._tax;
  }
  get shipping() {
    return this._shipping;
  }
  getCurrentCurrency() {
    return this.siteStore.getCurrencyHeader() || this._currency;
  }
  async loadConfig(shouldUsePublicApi) {
    if (shouldUsePublicApi && this.experiments.enabled(USE_GET_CLIENT_CONFIG_FROM_PUBLIC_API)) {
      var _publicApi$settings;
      const publicApi = await this.wixCodeApi.site.getPublicAPI(STORES_APP_DEF_ID);
      const settings = await (publicApi == null || (_publicApi$settings = publicApi.settings) == null || _publicApi$settings.getOnlineStoresSettings == null ? void 0 : _publicApi$settings.getOnlineStoresSettings());
      if (!settings) {
        await this.loadConfigFromSiteStore();
        return;
      }
      this._locale = getSupportedLanguageOrDefault(this.flowAPI.environment.language);
      this._currency = this.wixCodeApi.site.currency;
      this._layoutDirection = this.flowAPI.environment.isRTL ? 'rtl' : 'ltr';
      this._price = settings.price;
      this._tax = settings.tax;
      this._shipping = settings.shipping;

      // SiteStore Side effect - We populate the store since common components rely on site store - need major refactoring there first.
      this.siteStore.taxName = settings.tax.localeTaxName;
      this.siteStore.priceSettings = {
        ...this.siteStore.priceSettings,
        showPriceRange: Boolean(settings.price.showPriceRange),
        showTaxDisclaimer: Boolean(settings.tax.showTaxDisclaimer),
        taxOnProduct: Boolean(settings.tax.includeTaxOnProduct),
        shippingDisclaimer: settings.shipping.shippingDisclaimer
      };
    } else {
      await this.loadConfigFromSiteStore();
    }
  }
  async initializeSuggestedCurrencyAutoSwitchToast(_ref) {
    let {
      httpClient,
      onToastIntent,
      componentId,
      pageName
    } = _ref;
    if (typeof window === 'undefined') {
      return;
    }
    try {
      const {
        initializeSuggestedCurrencyAutoSwitch
      } = await import('@wix/payments-currency-autoswitch');
      const biEventParams = {
        appid: STORES_APP_DEF_ID,
        msid: this.siteStore.storeId,
        visitorId: this.siteStore.uuid,
        ...(componentId ? {
          componentId
        } : {}),
        ...(pageName ? {
          pageName
        } : {})
      };
      await initializeSuggestedCurrencyAutoSwitch({
        httpClient,
        location: this.wixCodeApi.location,
        storageKey: this.siteStore.storeId,
        currentCurrencyCode: this.getCurrentCurrency() || this.siteStore.currency,
        onToastIntent,
        biEventParams
      });
    } catch (e) {
      var _this$flowAPI$reportE, _this$flowAPI;
      const error = e instanceof Error ? e : new Error(String(e));
      (_this$flowAPI$reportE = (_this$flowAPI = this.flowAPI).reportError) == null || _this$flowAPI$reportE.call(_this$flowAPI, error);
      console.error(error);
    }
  }
  async loadConfigFromSiteStore() {
    await this.siteStore.loadClientConfig();
    this._locale = this.siteStore.locale;
    this._currency = this.siteStore.currency;
    this._layoutDirection = this.siteStore.layoutDirection;
    this._premiumFeatures = this.siteStore.premiumFeatures;
    this._price = {
      showPriceRange: this.siteStore.priceSettings.showPriceRange
    };
    this._tax = {
      localeTaxName: this.siteStore.taxName,
      includeTaxOnProduct: this.siteStore.priceSettings.taxOnProduct,
      showTaxDisclaimer: this.siteStore.priceSettings.showTaxDisclaimer
    };
    this._shipping = {
      shippingDisclaimer: this.siteStore.priceSettings.shippingDisclaimer
    };
  }
}
//# sourceMappingURL=ViewerContext.js.map